import { render } from "./WeddingViewFormType2.vue?vue&type=template&id=647f8372&lang=true"
import script from "./WeddingViewFormType2.vue?vue&type=script&lang=js"
export * from "./WeddingViewFormType2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__